import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MessagingService } from 'src/app/providers/messaging.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SharedService } from 'src/app/providers/shared.service';
import { AddNewCreditComponent } from 'src/app/shared/components/add-new-credit/add-new-credit.component';
import { AddServiceTemplateItemComponent } from 'src/app/shared/components/add-service-template-item/add-service-template-item.component';
import { AddServiceTimingsComponent } from 'src/app/shared/components/add-service-timings/add-service-timings.component';
import { AddServiceComponent } from 'src/app/shared/components/add-service/add-service.component';
import { CreditDetailsComponent } from 'src/app/shared/components/credit-details/credit-details.component';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { RenewBusinessComponent } from 'src/app/shared/components/renew-business/renew-business.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-employee-only-my-credits',
  templateUrl: './employee-only-my-credits.component.html',
  styleUrls: ['./employee-only-my-credits.component.scss']
})
export class EmployeeOnlyMyCreditsComponent implements OnInit, OnDestroy {
  entityHashId: string = '';
  employeeHash: string = '';
  serviceType: string = '';
  public loader: boolean = false;
  serviceTimings: any = []
  finalServiceTimings: any = [{
    dayName: "Entity Monthly Plan",
    openTime: "28 Nov, 2023",
    closeTime: "27 Dec, 2023",
    status: "Active"
  }]
  expenseData: any[] = [];
  private _apiSubscription: Subscription;
  datalength!: number
  public page: number = 1;
  searchString: FormControl = new FormControl('');

  daysOfWeek = [
    { day: 1, name: 'Sunday' },
    { day: 2, name: 'Monday' },
    { day: 3, name: 'Tuesday' },
    { day: 4, name: 'Wednesday' },
    { day: 5, name: 'Thursday' },
    { day: 6, name: 'Friday' },
    { day: 7, name: 'Saturday' }
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant('pay_credits.column_headers.date'),
      columnProperty: "creationDate"
    },
    {
      columnName: this.translateService.instant('pay_credits.column_headers.amount'),
      columnProperty: "amount"
    },
    
    {
      columnName: this.translateService.instant('pay_credits.column_headers.reason'),
      columnProperty: "purpose"
    },
    
    {
      columnName: this.translateService.instant('pay_credits.column_headers.type'),
      columnProperty: "payment_mode1"
    },
    {
      columnName: this.translateService.instant('pay_credits.column_headers.notes'),
      columnProperty: "repaymentNotes"
    },
    {
      columnName: this.translateService.instant('pay_credits.column_headers.pay_date'),
      columnProperty: "aproxRepaymentDate"
    },
    {
      columnName: this.translateService.instant('pay_credits.column_headers.status'),
      columnProperty: "status1"
    }
  ];
  constructor(private translateService: TranslateService,private _navService: NavigationService, private route: ActivatedRoute, private _apiService: ApiService, private _modelRef: MatDialog, private sharedService: SharedService, private loaderservice: LoaderServiceService,private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging) { 
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_USER_EXPENSES_LIST){
        this.expenseData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            if(element.payment_mode == 1){
              element.payment_mode1 = 'cash'
            }
            else if(element.payment_mode == 2){
              element.payment_mode1 = 'bank'
            }
            else if(element.payment_mode == 3){
              element.payment_mode1 = 'wallet'
            }

            if(element.status == 1){
              element.status1 = 'active'
            }
            else if(element.status == 0){
              element.status1 = 'Not active'
            }

            // element.c_amount = 
            this.expenseData.push(element)  
          });
          
        }
        this.loader = false;
      this.loaderservice.showLoader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_USER_EXPENSES_INFO){ 
        
        if(resData.result){
          this.loaderservice.showLoader = false
          this.ngOnInit()
        }
       }

       this.translateService.onLangChange.subscribe(() => {
        // Update your column headers when the language changes
        this.updateColumnHeaders();
      });
      
    });
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "date",
        "amount",
        "reason",
        "type",
        "notes",
        "pay_date",
        "status",
        
      ]
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`pay_credits.column_headers.${data[index]}`);
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  ngOnInit(): void {
    
   
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
      this.employeeHash = data.employeeHash
      
    })
    this.loader = true;
    this.loaderservice.showLoader = true
    this._apiService.getUserExpensesList(this.entityHashId, this.employeeHash)

    // if(this.serviceType == '0'){
    //   this.loaderservice.showLoader = true
    //   this._apiService.getHomeServiceTimeDetails(this.entityHashId)
    // }
    // else if(this.serviceType == '1'){
    //   this.loaderservice.showLoader = true
    //   this._apiService.getShopEntityTimeDetails(this.entityHashId)
    // }


    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });

  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService(){
this._modelRef.open(AddServiceComponent, {
      width: '700px',
      data: {
        title: 'Add service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
  }
  onCreateNewServiceFromTemplate(){
this._modelRef.open(AddServiceTemplateItemComponent, {
      width: '1000px',
      data: {
        title: 'Add service From Template',
        ref: this._modelRef,
      },
    });
  }

  openAddTime(rowvalue:any){
    rowvalue.serviceType = this.serviceType
    rowvalue.entityHash = this.entityHashId
    this._modelRef.open(AddServiceTimingsComponent, {
      width: '500px',
      data: {
        title: 'Add service timing',
        ref: this._modelRef,
        data: rowvalue
      },
    });
  }

  removeTime(rowvalue:any){
    if(this.serviceType == '0'){
      let data = {
        homeServiceTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this._apiService.updateHomeServiceTimeInfo(
        this.entityHashId,
        data
      );
    }
    else if(this.serviceType == '1'){
      let data = {
        entityTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this._apiService.updateEntityShopTimeInfo(
        this.entityHashId,
        data
      );
    }
  }

  deactivateService(rowvalue: any){
console.log(rowvalue);
let metadata = {
  serviceTypeInfo: {
    hash_id: rowvalue.hash_id,
    status: 7
  }
}

this._apiService.addUpdateServiceType(metadata, this.entityHashId)

// setTimeout(() => {
//   this.ngOnInit();
// }, 1500);

  }

  activateService(rowvalue:any){
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1
      }
    }
    
    this._apiService.addUpdateServiceType(metadata, this.entityHashId)
    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue:any){
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1
      }
    }

    this._apiService.addUpdateServiceType(metadata, this.entityHashId)
    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue:any){
    this._modelRef.open(AddServiceComponent, {
      width: '700px',
      data: {
        title: 'Add service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  
  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    
    //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  firstTimeBelow3:boolean = false;

  searchServiceData(){
    if(this.searchString.value.length >= 3){
      this.firstTimeBelow3 = true
      this.page = 1
      this._apiService.getServiceDataByKeyword(this.entityHashId,this.page, this.searchString.value)
    }
    else{
      if (this.firstTimeBelow3) {
      this.firstTimeBelow3 = false
      this.page = 1
      //this._apiService.getServices(this.entityHashId, this.page.toString())
      }
    }
  }

  reset(){
    this.searchString.reset()
    this.page = 1
    //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  renewBusiness(){
    this._modelRef.open(RenewBusinessComponent, {
      width: '500px',
      data: {
        title: 'Recharge Business',
        ref: this._modelRef,
        data: this.entityHashId
      },
    });
}

payCredit(){
  let data = {
    employeeHash: this.employeeHash,
    entityHash: this.entityHashId,
    editMode: false
  }
  this._modelRef.open(AddNewCreditComponent, {
    width: '500px',
    data: {
      title: 'New Credit',
      ref: this._modelRef,
      data: data
    },
  });
}

addPayback(rowvalue:any){
  let data = {
    employeeHash: this.employeeHash,
    entityHash: this.entityHashId,
    editMode: true,
    creditData: rowvalue
  }
  this._modelRef.open(AddNewCreditComponent, {
    width: '400px',
    data: {
      title: 'Add Payback',
      ref: this._modelRef,
      data: data
    },
  });
}

viewDetails(item:any){
  this._modelRef.open(CreditDetailsComponent, {
    width: '500px',
    data: {
      title: 'Credit Details',
      ref: this._modelRef,
      data: item
    },
  });
}

deleteCredit(rowvalue:any){
  const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
    data : {
      title : 'Alert',
      message : 'Are you sure you want to delete this credit?',
      okbtn : 'Confirm',
      cancelbtn : 'Cancel',
      type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
    },
    disableClose : true
  });
  dialogRef.afterClosed().subscribe(result=>{
    console.log(result);
    if(result){ 
      let data = {
        expenseInfo : {
          hash_id: rowvalue.hash_id,
          isDelete: 1
        }
       }
       this.loaderservice.showLoader = true
       this._apiService.updateUserExpenseInfo(this.employeeHash,data,this.entityHashId)
    }
  })

}
  convertTo12HourFormat(timeString:any) {
    
    const [hours, minutes] = timeString.split(':');
    let period = 'AM';
    let hour = parseInt(hours, 10);
  
    if (hour >= 12) {
      period = 'PM';
      if (hour > 12) {
        hour -= 12;
      }
    }
  
    return `${hour.toString().padStart(2, '0')}:${minutes} ${period}`;
  }


}


